import { AppState } from "../../state";
import { createSelector } from "reselect";

export const getOrderHubState = (state: AppState) => state.orderHub;

export const getConnectionStatus = createSelector(getOrderHubState, ({ status }) => status);
